export const getCurityRedirectUri = () =>
  `${window.location.origin}/auth/callback`;
